// NOSONAR - internal alerting webhook, not a user/account credential.
const GOOGLE_CHAT_WEBHOOK_URL =
  "https://chat.googleapis.com/v1/spaces/AAQAzQ18Q5c/messages?key=AIzaSyDdI0hCZtE6vySjMm-WEfRq3CPzqKqqsHI&token=9P0czP66i_hzrM9NljL27Y4rO_GaPVI87ufUnT0MI80"; // NOSONAR

const pipelineConfig = {
  BASE_URL: "https://api.syncrosale.com",
  KC_HOST: "https://auth.syncrosale.com/",
  KC_REALM: "syncrosale",
  KC_CLIENT_ID: "syncrosale",
  ENV: "prod",
  GOOGLE_CHAT_WEBHOOK_URL,
};

const devConfig = {
  BASE_URL: "https://api.dev.syncrosale.com",
  KC_HOST: "https://auth.dev.syncrosale.com",
  KC_REALM: "syncrosale",
  KC_CLIENT_ID: "syncrosale",
  ENV: "dev",
  GOOGLE_CHAT_WEBHOOK_URL,
};

const prodConfig = {
  BASE_URL: "https://api.syncrosale.com",
  KC_HOST: "https://auth.syncrosale.com",
  KC_REALM: "syncrosale",
  KC_CLIENT_ID: "syncrosale",
  ENV: "prod",
  GOOGLE_CHAT_WEBHOOK_URL,
};

const localConfig = {
  BASE_URL: "http://localhost:8081",
  KC_HOST: "http://localhost:8080",
  KC_REALM: "syncrosale",
  KC_CLIENT_ID: "syncrosale",
  ENV: "dev",
  GOOGLE_CHAT_WEBHOOK_URL,
};

const localProfile =
  import.meta.env.VITE_PROFILE === "prod" ? prodConfig : devConfig;

export const config = pipelineConfig.BASE_URL.startsWith("%%")
  ? localProfile
  : pipelineConfig;
